// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '../../model/environment.config';

export const config: EnvironmentConfig = {
  production: true,
  apiRoot: 'https://deal-hunter-registration-jp.jp-preprod.cosmose.cloud/deal-hunter-registration-api/v1',
  dhApiRoot: 'https://deal-hunter-preprod.singapurr-prod1.cosmose.cloud',
  ppApiRoot: 'https://api.sg.cosmose.co/deal-hunter-partner-api/v1',
  smartLookIntegration: false,
  contentful: {
    accessToken: 'nJ6gXFfV3meRAqTT98eU0p2vJWo4KfWPAr4nZRfRk7c',
    space: 'bt9hwdef88x8',
    host: 'cdn.contentful.com',
    regionEntryId: '6iWJXMlSHAxSci6nsBjj9Z',
  },
};
